import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => (
  <footer className="py-6 mt-auto text-center">
    <Link
      to="/privacy"
      className="text-zinc-600 hover:text-zinc-400 text-xs transition-colors"
    >
      Privacy Policy
    </Link>
  </footer>
);

export default Footer;
